import { useNavigate } from "react-router-dom";
import ExportCSVButton from "../../../Components/ExportCSVButton";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { useContext, useState } from "react";
import ClearFilterButton from "../../../Components/ClearFilterButton"; 
import UpcomingDonationsListTable from "./UpcomingDonationsListTable";
import DateRangeDropdown from "../../../Components/AdministrativeSettings/DateRangeDropdown";

function UpcomingDonations({donorId, userType}) {


    const navigate = useNavigate();
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);

    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const [exportCsv, setexportCsv] = useState(false);
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };

    const dateRanges = [
        { label: 'Next 30 days', value: '30 days' },
        { label: 'Next 60 days', value: '60 days' },
        { label: 'Next 90 days', value: '90 days' },
        { label: 'Next 6 months', value: '6 months' },
        { label: 'Next 12 months', value: '12 months' }
    ];


    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };

    const handleExportCSV = () => {
        setexportCsv(true);
        setTimeout(() => setexportCsv(false), 0);
    }

    const [selectedRange, setSelectedRange] = useState('90 days');

    const handleDateRangeChange = (eventKey) => {
        setSelectedRange(eventKey); // Update selected date range based on user selection
    };
    return (<>

        <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-between align-items-center">
                <div style={{ marginRight: '15px' }}>
                    <h3>Upcoming Donations
                    </h3>
                </div>

                <ExportCSVButton handleExportCSV={handleExportCSV} />
                {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                {/* <select class="form-select el-filled-btns px-1 w-f-content text-center" aria-label="Default select example">
                    <option selected>Last 30 days</option>
                    <option value="1">Last 60 days</option>
                    <option value="2">Last 90 days</option>
                    <option value="3">Last 6 months</option>
                    <option value="3">Last 12 months</option>
                </select> */}
            </div>
                <DateRangeDropdown
                selectedRange={selectedRange}
                handleDateRangeChange={handleDateRangeChange}
                dateRanges={dateRanges}
            />
        </div>
        <>  
            <UpcomingDonationsListTable isClearFilter={isClearFilter} selectedRange={selectedRange} onFilterCountChange={handleFilterCountChange} exportCsv={exportCsv} donorId={donorId} userType={userType}/>
        </>
    </>);
}

export default UpcomingDonations


